import MayaUnsupportedBrowser from './MayaUnsupportedBrowser'

export default MayaUnsupportedBrowser
